import { Text } from '@components/ui';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import {
  type JobKindBucket,
  jobKindBucket,
  jobKindDetailKey,
  jobKindHintKey,
  type JobKindSource,
  jobKindTitleKey,
} from './jobKind';

const chipSx = {
  display: 'inline-flex',
  alignItems: 'baseline',
  gap: 0.5,
  px: 1,
  py: 0.25,
  borderRadius: 999,
  bgcolor: 'action.hover',
  maxWidth: '100%',
} as const;

interface JobKindChipProps {
  job?: JobKindSource;
  bucket?: JobKindBucket;
}

export const JobKindChip = ({
  job,
  bucket,
}: JobKindChipProps): JSX.Element | null => {
  const { t } = useTranslation();
  const resolved = bucket ?? (job ? jobKindBucket(job) : null);
  if (resolved == null) {
    return null;
  }

  return (
    <Box component="span" title={t(jobKindHintKey(resolved))} sx={chipSx}>
      <Text variant="caption" tone="muted" sx={{ lineHeight: 1.3 }}>
        {t(jobKindTitleKey(resolved))}
      </Text>
    </Box>
  );
};

export const JobKindNote = ({ job }: { job: JobKindSource }): JSX.Element => {
  const { t } = useTranslation();
  const bucket = jobKindBucket(job);

  return (
    <Box
      component="span"
      title={t(jobKindDetailKey(job))}
      sx={{ ...chipSx, alignSelf: 'flex-start' }}
    >
      <Text variant="caption" tone="muted" sx={{ lineHeight: 1.3 }}>
        {t(jobKindTitleKey(bucket))}
      </Text>
    </Box>
  );
};
